// Attributs Active Directory standard avec leurs shortcodes
export const AD_ATTRIBUTES = [
  {
    category: 'Identité',
    attributes: [
      { shortcode: '{firstname}', label: 'Prénom', adAttribute: 'givenName', example: 'Jean' },
      { shortcode: '{lastname}', label: 'Nom', adAttribute: 'sn', example: 'Dupont' },
      { shortcode: '{displayname}', label: 'Nom complet', adAttribute: 'displayName', example: 'Jean Dupont' },
      { shortcode: '{initials}', label: 'Initiales', adAttribute: 'initials', example: 'J.D.' },
      { shortcode: '{username}', label: 'Nom d\'utilisateur', adAttribute: 'sAMAccountName', example: 'jdupont' }
    ]
  },
  {
    category: 'Contact',
    attributes: [
      { shortcode: '{email}', label: 'Email', adAttribute: 'mail', example: 'jean.dupont@entreprise.com' },
      { shortcode: '{phone}', label: 'Téléphone', adAttribute: 'telephoneNumber', example: '+33 1 23 45 67 89' },
      { shortcode: '{mobile}', label: 'Mobile', adAttribute: 'mobile', example: '+33 6 12 34 56 78' },
      { shortcode: '{fax}', label: 'Fax', adAttribute: 'facsimileTelephoneNumber', example: '+33 1 23 45 67 90' },
      { shortcode: '{ipphone}', label: 'Téléphone IP', adAttribute: 'ipPhone', example: '1234' }
    ]
  },
  {
    category: 'Organisation',
    attributes: [
      { shortcode: '{jobtitle}', label: 'Titre du poste', adAttribute: 'title', example: 'Directeur des ventes' },
      { shortcode: '{department}', label: 'Département', adAttribute: 'department', example: 'Commercial' },
      { shortcode: '{company}', label: 'Entreprise', adAttribute: 'company', example: 'Acme Corp' },
      { shortcode: '{manager}', label: 'Manager', adAttribute: 'manager', example: 'Marie Martin' },
      { shortcode: '{office}', label: 'Bureau', adAttribute: 'physicalDeliveryOfficeName', example: 'Paris - 3ème étage' }
    ]
  },
  {
    category: 'Adresse',
    attributes: [
      { shortcode: '{street}', label: 'Rue', adAttribute: 'streetAddress', example: '123 Rue de la Paix' },
      { shortcode: '{city}', label: 'Ville', adAttribute: 'l', example: 'Paris' },
      { shortcode: '{state}', label: 'État/Région', adAttribute: 'st', example: 'Île-de-France' },
      { shortcode: '{zipcode}', label: 'Code postal', adAttribute: 'postalCode', example: '75001' },
      { shortcode: '{country}', label: 'Pays', adAttribute: 'co', example: 'France' }
    ]
  },
  {
    category: 'Web & Social',
    attributes: [
      { shortcode: '{website}', label: 'Site web', adAttribute: 'wWWHomePage', example: 'www.entreprise.com' },
      { shortcode: '{linkedin}', label: 'LinkedIn', adAttribute: 'extensionAttribute1', example: 'linkedin.com/in/jdupont' },
      { shortcode: '{twitter}', label: 'Twitter', adAttribute: 'extensionAttribute2', example: '@jdupont' },
      { shortcode: '{facebook}', label: 'Facebook', adAttribute: 'extensionAttribute3', example: 'facebook.com/jdupont' }
    ]
  },
  {
    category: 'Autres',
    attributes: [
      { shortcode: '{description}', label: 'Description', adAttribute: 'description', example: 'Expert en marketing digital' },
      { shortcode: '{employeeid}', label: 'ID Employé', adAttribute: 'employeeID', example: 'EMP12345' },
      { shortcode: '{employeenumber}', label: 'N° Employé', adAttribute: 'employeeNumber', example: '12345' }
    ]
  },
  {
    category: 'Personnalisation',
    attributes: [
      { shortcode: '{greeting}', label: 'Formule de politesse', adAttribute: 'greeting', example: 'Cordialement,' },
      { shortcode: '{profile_photo}', label: 'Photo de profil (URL)', adAttribute: 'profile_photo', example: '' },
      { shortcode: '{org_logo}', label: 'Logo organisation (URL)', adAttribute: 'org_logo', example: '' }
    ]
  }
];

// Fonction utilitaire pour obtenir tous les shortcodes à plat
export const getAllShortcodes = () => {
  const allShortcodes = [];
  AD_ATTRIBUTES.forEach(category => {
    category.attributes.forEach(attr => {
      allShortcodes.push(attr);
    });
  });
  return allShortcodes;
};

// Fonction pour obtenir le label d'un shortcode
export const getShortcodeLabel = (shortcode) => {
  const allShortcodes = getAllShortcodes();
  const found = allShortcodes.find(attr => attr.shortcode === shortcode);
  return found ? found.label : shortcode;
};

// Fonction pour remplacer les shortcodes par des exemples (pour prévisualisation)
export const replaceShortcodesWithExamples = (text) => {
  if (!text) return text;

  let result = text;
  const allShortcodes = getAllShortcodes();

  allShortcodes.forEach(attr => {
    const regex = new RegExp(attr.shortcode.replace(/[{}]/g, '\\$&'), 'g');
    result = result.replace(regex, attr.example);
  });

  return result;
};

// Fonction pour remplacer les shortcodes par des données réelles (pour production)
export const replaceShortcodesWithData = (text, userData) => {
  if (!text || !userData) return text;

  let result = text;
  const allShortcodes = getAllShortcodes();

  allShortcodes.forEach(attr => {
    const regex = new RegExp(attr.shortcode.replace(/[{}]/g, '\\$&'), 'g');
    const value = userData[attr.adAttribute] || '';
    result = result.replace(regex, value);
  });

  return result;
};
